
(function () {
  var header = document.querySelector('[data-home-nav]');
  if (!header) return;
  var pending = false;
  function update() {
    pending = false;
    header.classList.toggle('is-floating', window.scrollY >= 240);
  }
  update();
  requestAnimationFrame(function () { header.classList.add('is-ready'); });
  window.addEventListener('scroll', function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  }, { passive: true });
  window.addEventListener('pageshow', update);
})();
